import {
  Box,
  Button,
  Paper,
  Toolbar
} from "@mui/material";
import html2canvas from "html2canvas";
import { default as React, useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useParams } from "react-router-dom";
import CompanySearchboxBody from "../../../components/Common/CompanySearchBody";
import CustomSkeleton from "../../../components/Common/CustomSkeleton";
import InfoboxHeader from "../../../components/Common/InfoboxHeader";
import SearchboxHeader from "../../../components/Common/SearchBoxHeader";
import { customDateConvert } from "../../../components/Common/Utils/Utils";
import { useLoading } from "../../../context/LoadingContext";
import { useQualityData } from "../../../context/QualityDataContext";
import { useSelectTagContext } from "../../../context/SelectTagContext";
import useApi from "../../../service/api.service";
import CFactorsGraph from "./CFactorsGraph";
import CFProductsGraph from "./CFProductsGraph";
import CFTrend from "./CFTrend";
import CompanyInfoboxTable from "./CompanyInfoboxTable";
import PTrendsGraph from "./PTrendsGraph";

function QualityInfo({ latestUpdateTime, items, onSelectedItem }) {
  const { partsData, productsData } = useQualityData();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const API = useApi();
  const [selectedItem, setSelectedItem] = useState("LN 1");
  const [anchorEl, setAnchorEl] = useState(null);
  const [notes, setNotes] = useState(data);
  const [filteredRows, setFilteredRows] = useState([]);
  const [updatedTable, setUpdatedTable] = useState(null);
  const [typeStatus, setTypeStatus] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const { loading, setLoading } = useLoading();
  const [pLoading, setPLoading] = useState(false);
  const [pLoading1, setPLoading1] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [currentState, setCurrentState] = useState(
    localStorage.getItem("currentState")
  );
  const {
    appliedFilters,
    setAppliedFilters,
    selectedFilters,
    setSelectedFilters,
    setMinRows,
    cancelFilters,
    setCancelFilters,
  } = useSelectTagContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [order, setOrder] = useState("desc");
  const [finalDate, setFinalDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [trendData, setTrendData] = useState(null);
  const [contributionData, setContributionData] = useState(null);
  // const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  // const [currentState, setCurrentState] = useState(() => {
  //   const statePrevData = location.state?.prevData;
  //   if (statePrevData) {
  //     localStorage.setItem("prevData", statePrevData);
  //     return statePrevData;
  //   } else {
  //     const storedPrevData = localStorage.getItem("prevData");
  //     return storedPrevData ? storedPrevData : [];
  //   }
  // });

  useEffect(() => {
    localStorage.setItem("currentState", currentState);
  }, [currentState]);

  useEffect(() => {
    // localStorage.setItem("prevData", JSON.stringify(prevData));
    const storedCustomParamsString = localStorage.getItem("customParams");
    const storedCustomParams = JSON.parse(storedCustomParamsString);
    storedCustomParams.startTime &&
      setAppliedFilters((prev) => ({
        ...prev,
        fromTimestamp: storedCustomParams.startTime,
      }));
    setSelectedFilters((prev) => ({
      ...prev,
      fromTimestamp: storedCustomParams.startTime,
    }));
    storedCustomParams.endTime &&
      setAppliedFilters((prev) => ({
        ...prev,
        toTimestamp: storedCustomParams.endTime,
      }));
    setSelectedFilters((prev) => ({
      ...prev,
      toTimestamp: storedCustomParams.endTime,
    }));
    storedCustomParams.statusType &&
      setAppliedFilters((prev) => ({
        ...prev,
        partPrediction: storedCustomParams.statusType,
      }));
    setSelectedFilters((prev) => ({
      ...prev,
      prediction: storedCustomParams.statusType,
    }));
    setCurrentPage(storedCustomParams.page);
    setItemsPerPage(storedCustomParams.limit);
    setMinRows(storedCustomParams.limit);
    setOrder(storedCustomParams.orderDirection);
    // setTotalPages(localStorage.getItem("totalPages"));
    return () => {
      setAppliedFilters(() => ({
        partID: "",
        partPrediction: "",
        partTimestamp: "",
        productID: "",
        productPrediction: "",
        productTimestamp: "",
        fromTimestamp: "",
        toTimestamp: "",
      }));
      setSelectedFilters(() => ({
        partID: "",
        productID: "",
        prediction: "",
        timestamp: "",
        factorsName: "",
        fromTimestamp: "",
        toTimestamp: "",
      }));
      setMinRows(10);
      setCancelFilters(false);
    };
  }, []);

  const fetchData = async () => {
    const customParams = {
      startTime:
        appliedFilters.fromTimestamp &&
        appliedFilters.fromTimestamp != "Invalid Date"
          ? customDateConvert(appliedFilters.fromTimestamp, "YYYY-MM-DD")
          : null,
      endTime:
        appliedFilters.toTimestamp &&
        appliedFilters.toTimestamp != "Invalid Date"
          ? customDateConvert(appliedFilters.toTimestamp, "YYYY-MM-DD")
          : null,
      statusType: appliedFilters.partPrediction
        ? appliedFilters.partPrediction
        : null,
      page: currentPage,
      limit: itemsPerPage,
      orderColumn: "dryTunelExitTime",
      orderDirection: order.toUpperCase(),
    };
    try {
      setLoading(true);
      const response = await API.getPartsList(customParams);
      setLoading(false);
      setUpdatedTable(response?.data?.parts);
      setPaginationData((prevState) => ({
        ...prevState,
        rowsPerPage: response?.data?.rowsPerPage,
        totalPages: response?.data?.totalPages,
        totalRows: response?.data?.totalRows,
      }));
      // setTotalPages(paginationData.totalPages);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchProductData = async () => {
    const customParams = {
      startTime:
        appliedFilters.fromTimestamp &&
        appliedFilters.fromTimestamp != "Invalid Date"
          ? customDateConvert(appliedFilters.fromTimestamp, "YYYY-MM-DD")
          : null,
      endTime:
        appliedFilters.toTimestamp &&
        appliedFilters.toTimestamp != "Invalid Date"
          ? customDateConvert(appliedFilters.toTimestamp, "YYYY-MM-DD")
          : null,
    };
    try {
      setPLoading(true);
      const response = await API.getProductsList(customParams);
      setPLoading(false);
      setUpdatedTable(response?.data);
    } catch (error) {
      setPLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (currentState === "By Parts") {
      if (
        (appliedFilters.fromTimestamp && appliedFilters.toTimestamp) ||
        appliedFilters.partPredictions
      ) {
        fetchData();
      }
    }
  }, [
    appliedFilters.fromTimestamp,
    appliedFilters.toTimestamp,
    appliedFilters.partPrediction,
    currentState,
  ]);
  useEffect(() => {
    if (currentState === "By Parts") {
      fetchData();
    }
  }, [currentPage, itemsPerPage, order, currentState]);
  useEffect(() => {
    if (currentState === "By Parts") {
      if (typeStatus) {
        fetchData();
      }
      setTypeStatus(false);
    }
  }, [typeStatus, currentState]);

  useEffect(() => {
    if (currentState === "By Parts") {
      if (cancelFilters) {
        fetchData();
      }
      setCancelFilters(false);
    }
  }, [cancelFilters, currentState]);

  // console.log("time", appliedFilters.fromTimestamp);
  // console.log("Date", selectedFilters.fromTimestamp);

  useEffect(() => {
    // const data = updatedTable !== null ? updatedTable : prevData;
    if (currentState === "By Parts") {
      // if (search.length === 0) {
      //   setFilteredRows(updatedTable);
      //   return;
      // }
      let filteredData = updatedTable?.filter((task) =>
        task?.partCode
          ?.toString()
          ?.toLowerCase()
          ?.includes(search?.toLowerCase())
      );
      setFilteredRows(filteredData);
    } else {
      let filteredData = updatedTable?.filter((task) =>
        task?.productCode
          ?.toString()
          ?.toLowerCase()
          ?.includes(search?.toLowerCase())
      );

      setFilteredRows(filteredData);
    }
  }, [currentState, search, appliedFilters, id, updatedTable]);

  // useEffect(() => {
  //   const idExistsInParts = partsData.some((item) => item.name === id);
  //   if (idExistsInParts) {
  //     setCurrentState("By Parts");
  //   } else {
  //     setCurrentState("By Products");
  //   }
  // }, []);

  useEffect(() => {
    if (currentState === "By Products") {
      fetchProductData();
    }
  }, [appliedFilters.fromTimestamp, appliedFilters.toTimestamp, currentState]);

  const totalPages = paginationData.totalPages;

  const handleSelectedItem = (selectedItemData) => {
    setData(selectedItemData);
  };

  const handleSearch = (input) => {
    setSearch(input);
    // console.log(search);
  };
  const handleSelectedHeaderItem = (item) => {
    setCurrentState(item);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (selectedItem) => {
    setSelectedItem(selectedItem);
    handleClose();
    onSelectedItem(selectedItem);
  };

  const styles = {
    titleTypography: {
      display: "flex",
      alignItems: "center",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
    },
    subtitleTypography: {
      color: "#9F9F9F",
      fontSize: "10px",
    },
    keyDownIcon: {
      fontSize: "17px",
      ml: 0.2,
      mr: 1,
    },
  };

  const captureRef = useRef(null);
  const takeScreenshot = () => {
    if (captureRef.current) {
      html2canvas(captureRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `PartID ${partByIdData?.partCode} Details.png`;
        link.click();
      });
      toast.success("Data downloaded successfully");
    }
  };

  const renderProduct = () => {
    return (
      <PTrendsGraph
        good={trendData?.good_parts}
        scrap={trendData?.scrapped_parts}
        categories={trendData?.timestamp}
      />
    );
  };

  const renderFactors = (data) => {
    const actual = data?.factors?.map((factor) => factor?.contribution);
    const categories = data?.factors?.map((factor) => factor?.factorName);
    return <CFactorsGraph actual={actual} categories={categories} />;
  };

  const renderProductsFactors = (data) => {
    return (
      <CFactorsGraph actual={data?.actualValue} categories={data?.factorName} />
    );
  };

  const [selectedButton, setSelectedButton] = useState(null);

  const arr = [
    { name: "Production Trend", isAuth: currentState === "By Products" },
    { name: "Contributing Factors", isAuth: true },
    { name: "Contributing Factors Trend", isAuth: true },
  ];

  const buttonStyle = (buttonName) => ({
    textTransform: "capitalize",
    color: "#404040",
    fontSize: "0.80rem",
    fontWeight: "500",
    marginRight: "5px",
    padding: "3px 15px",
    backgroundColor:
      selectedButton === buttonName ? "#0077B61A" : "transparent",
    borderRadius: "25px",
    border: selectedButton === buttonName ? "1px solid #0077B6" : "none",
  });

  useEffect(() => {
    setSelectedButton(
      currentState === "By Parts" ? "Contributing Factors" : "Production Trend"
    );
  }, [currentState]);

  const [partByIdData, setPartByIdData] = useState(null);

  const getPartById = async () => {
    try {
      setLoading1(true);
      const response = await API.getPartById(id);
      setLoading1(false);
      setPartByIdData(response.data);
    } catch (error) {
      setLoading1(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (currentState === "By Parts") {
      getPartById();
    }
  }, [id, currentState]);
  useEffect(() => {
    if (typeStatus) {
      if (currentState === "By Parts") {
        getPartById();
      }
      setTypeStatus(false);
    }
  }, [typeStatus, currentState]);

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleChangeItemsPerPage = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  const fetchTrendData = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(new Date(finalDate.startDate).toLocaleDateString("en-US"), "YYYY-MM-DD")
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(new Date(finalDate.endDate).toLocaleDateString("en-US"), "YYYY-MM-DD")
        : null,
    };
    try {
      setPLoading1(true);
      const response = await API.getProductByTrend(id, customParams);
      setPLoading1(false);
      setTrendData(response?.data);
    } catch (error) {
      setPLoading1(false);
      console.error("Error fetching data:", error);
    }
  };
  const fetchContributionData = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(new Date(finalDate.startDate).toLocaleDateString("en-US"), "YYYY-MM-DD")
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(new Date(finalDate.endDate).toLocaleDateString("en-US"), "YYYY-MM-DD")
        : null,
    };
    try {
      setPLoading1(true);
      const response = await API.getProductByFactors(id, customParams);
      setPLoading1(false);
      setContributionData(response?.data);
    } catch (error) {
      setPLoading1(false);
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (currentState === "By Products") {
      if (selectedButton === "Production Trend") {
        fetchTrendData();
      }
      if (
        selectedButton === "Contributing Factors" ||
        selectedButton === "Contributing Factors Trend"
      ) {
        fetchContributionData();
      }
    }
  }, [id, finalDate, selectedButton]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "98%",
          mx: "auto",
          gap: "20px",
          pt: 3,
          boxSizing: "border-box",
          height: `calc(100vh - 110px)`,
          overflow: "auto",
        }}
      >
        {/* {loading ? (
          <CircularSkeleton />
        ) : ( */}
        <>
          <Paper
            sx={{
              display: "flex",
              width: "23%",
              borderRadius: "20px",
              flexDirection: "column",
              height: "100%",
              overflowY: "hidden",
              boxShadow: "none",
              border: "1px solid #E4E4E4",
            }}
          >
            {/* <div style={{ padding: "10px", borderBottom: "1px solid #E4E4E4" }}>
            <Box sx={{ flexDirection: "column" }}>
              <Typography sx={styles.titleTypography} onClick={handleClick}>
                {selectedItem}
                <KeyboardArrowDownIcon sx={styles.keyDownIcon} />
              </Typography>
              <Typography sx={styles.subtitleTypography}>
                {data?.length} Parts &bull; Updated {latestUpdateTime}
              </Typography>
            </Box>
          </div>
          <div
            style={{
              padding: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderBottom: "1px solid #E4E4E4",
              fontWeight: 500,
            }}
          >
            <Box>Today's Production Summary</Box>
            <LinearProgress
              variant="determinate"
              value={90}
              sx={{
                height: "12px",
                backgroundColor: theme.colors.scrap,
                borderRadius: "3px",
                "& .css-5xe99f-MuiLinearProgress-bar1": {
                  backgroundColor: theme.colors.good,
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <p>Total Parts</p>
                <p style={{ fontWeight: 400, color: "#505050" }}>2,143</p>
              </div>
              <div>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <StopRoundedIcon sx={{ color: theme.colors.good }} />
                  Good
                </p>
                <p style={{ fontWeight: 400, color: "#505050" }}>1,879</p>
              </div>
              <div>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <StopRoundedIcon sx={{ color: theme.colors.scrap }} />
                  Scrap
                </p>
                <p style={{ fontWeight: 400, color: "#505050" }}>264</p>
              </div>
            </div>
          </div> */}
            <SearchboxHeader
              onSearch={handleSearch}
              // data={currentState === "By Parts" ? partsData : productsData}
              data={filteredRows}
              // latestUpdateTime={latestUpdateTime}
              items={["By Parts", "By Products"]}
              page={currentState}
              // onApplyFilters={applyFiltersAndFetch}
              onSelectedItem={handleSelectedHeaderItem}
            />
            <Box sx={{ overflow: "auto", height: "100%" }}>
              {loading ? (
                <CustomSkeleton />
              ) : (
                <CompanySearchboxBody
                  // data={currentState === "By Products" ? productsData : partsData}
                  data={filteredRows}
                  // fieldMapping={fieldMapping}
                  onItemSelected={handleSelectedItem}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handleChangePage={handleChangePage}
                  handleChangeItemsPerPage={handleChangeItemsPerPage}
                  currentState={currentState}
                />
              )}
            </Box>
          </Paper>
          <Box
            sx={{
              width: "77%",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflow: "auto",
            }}
            ref={captureRef}
          >
            <Paper
              sx={{
                borderRadius: "20px",
                // boxShadow: "0px 3px 6px #0000001F",
                boxShadow: "none",
                border: "1px solid #E4E4E4",
                marginBottom: "20px",
              }}
            >
              {loading1 || loading ? (
                <CustomSkeleton height="160px" />
              ) : (
                <>
                  <InfoboxHeader
                    head={partByIdData}
                    page={currentState}
                    productsData={filteredRows}
                    comId=""
                    downloadPermission={takeScreenshot}
                    setTypeStatus={setTypeStatus}
                    finalDate={finalDate}
                    setFinalDate={setFinalDate}
                  />
                  <CompanyInfoboxTable
                    info={partByIdData}
                    dataType={currentState}
                    page={currentState}
                    productsData={filteredRows}
                  />
                </>
              )}
            </Paper>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                height: `calc(100% - 185px)`,
                maxHeight: `calc(100% - 185px)`,
                // overflow: "auto",
              }}
            >
              <Paper
                sx={{
                  borderRadius: "20px",
                  width: "100%",
                  // boxShadow: "0px 3px 6px #0000001F",
                  boxShadow: "none",
                  border: "1px solid #E4E4E4",
                }}
              >
                <>
                  <Toolbar
                    variant="dense"
                    sx={{
                      borderBottom: "1px solid #D1D1D1",
                    }}
                  >
                    {arr.map(
                      ({ name, isAuth }) =>
                        isAuth && (
                          <Button
                            key={name}
                            sx={buttonStyle(name)}
                            onClick={() => setSelectedButton(name)}
                          >
                            {name}
                          </Button>
                        )
                    )}
                  </Toolbar>
                  <div
                    style={{
                      height: "80%",
                      backgroundColor: "white",
                    }}
                  >
                    {(loading1 && !loading) || pLoading1 ? (
                      <CustomSkeleton height="350px" />
                    ) : (
                      <>
                        {selectedButton === "Production Trend" &&
                          renderProduct()}
                        {selectedButton === "Contributing Factors" && (
                          <>
                            {currentState === "By Parts" &&
                              renderFactors(partByIdData)}
                            {currentState === "By Products" &&
                              renderProductsFactors(contributionData)}
                          </>
                        )}
                        {selectedButton === "Contributing Factors Trend" && (
                          <>
                            {currentState === "By Parts" && (
                              <CFTrend data={partByIdData} />
                            )}
                            {currentState === "By Products" && (
                              <CFProductsGraph data={contributionData} />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </>
              </Paper>
              {/* <Paper
                sx={{
                  borderRadius: "20px",
                  width: "34%",
                  height: "100%",
                  // boxShadow: "0px 3px 6px #0000001F",
                  boxShadow: "none",
                  border: "1px solid #E4E4E4",
                }}
              >
                <SidePanelHeader type="company" id="" />
              </Paper> */}
            </Box>
          </Box>
          <Toaster />
        </>
        {/* )} */}
      </Box>
    </>
  );
}

export default QualityInfo;
